import { Transition } from '@headlessui/react';
import { FC, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { accordionClassNames } from '../../../common';
import { ExpandButton } from '../../../common/Buttons';
import { InputField } from '../../../common/Inputs';
import { FormRow } from '../../../common/LayoutComponents';
import { StopAreaFormState } from '../../../StopRegistry/StopAreas/Common';
import { StopAreaEnglishNames } from './StopAreaEnglishNames';

const ID = 'StopAreaNameSection';
const HeaderId = 'StopAreaNameSection::Header';

const testIds = {
  showHideButton: 'StopAreaFormComponent::showHideButton',
  nameSwe: 'StopAreaFormComponent::nameSwe',
  nameLongFin: 'StopAreaFormComponent::nameLongFin',
  nameLongSwe: 'StopAreaFormComponent::nameLongSwe',
  abbreviationFin: 'StopAreaFormComponent::abbreviationFin',
  abbreviationSwe: 'StopAreaFormComponent::abbreviationSwe',
  errorIndicator: 'StopAreaFormComponent::errorIndicator',
};

export const StopAreaNames: FC = () => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const {
    formState: { errors },
  } = useFormContext<StopAreaFormState>();

  // Check if there are any errors in the fields that are hidden when collapsed
  const hasHiddenErrors =
    errors.nameSwe ??
    errors.nameLongFin ??
    errors.nameLongSwe ??
    errors.abbreviationFin ??
    errors.abbreviationSwe;

  return (
    <>
      <div className="flex items-center">
        {!expanded && hasHiddenErrors && (
          <div
            className="mr-2 w-1/2 text-hsl-red"
            data-testid={testIds.errorIndicator}
          >
            <span>{t(($) => $.stopArea.errors.expandToSeeErrors)}</span>
          </div>
        )}
        <ExpandButton
          className="ml-auto"
          ariaControls={ID}
          expanded={expanded}
          expandedText={t(($) => $.stops.stopArea.showDetails)}
          onClick={() => setExpanded((p) => !p)}
          testId={testIds.showHideButton}
          iconClassName="text-base"
        />
      </div>
      <Transition
        as="div"
        className="mt-2 flex flex-row flex-wrap gap-8 py-2"
        id={ID}
        role="region"
        show={expanded}
        aria-hidden={!expanded}
        aria-labelledby={HeaderId}
        {...accordionClassNames}
      >
        <FormRow mdColumns={3} className="sm:gap-x-4 md:gap-x-4 lg:gap-x-4">
          <InputField<StopAreaFormState>
            type="text"
            translationPrefix="stopArea"
            fieldPath="nameSwe"
            testId={testIds.nameSwe}
          />

          <InputField<StopAreaFormState>
            type="text"
            translationPrefix="stopDetails.basicDetails"
            fieldPath="nameLongFin"
            testId={testIds.nameLongFin}
          />
          <InputField<StopAreaFormState>
            type="text"
            translationPrefix="stopDetails.basicDetails"
            fieldPath="nameLongSwe"
            testId={testIds.nameLongSwe}
          />
          <InputField<StopAreaFormState>
            type="text"
            translationPrefix="stopDetails.basicDetails"
            fieldPath="abbreviationFin"
            testId={testIds.abbreviationFin}
          />
          <InputField<StopAreaFormState>
            type="text"
            translationPrefix="stopDetails.basicDetails"
            fieldPath="abbreviationSwe"
            testId={testIds.abbreviationSwe}
          />
        </FormRow>
        <FormRow className="w-full">
          <StopAreaEnglishNames />
        </FormRow>
      </Transition>
    </>
  );
};
